import { Component } from '@angular/core';
import { WorkflowPageNavigationService } from '../../../service/workflow-page-navigation/workflow-page-navigation.service';
import { CardElementsBaseComponent } from './card-elements-base.component';

// Fix for Component ID generation collision detected
// https://angular.io/errors/NG0912
@Component({
  selector: 'not:(p)', // Fix for Component ID generation collision detected
  template: '',
  standalone: false
})
/** Base Component Class for page elements */
export class CoreReviewCardRendererBaseComponent extends CardElementsBaseComponent {
  constructor(public readonly workflowNavigationService: WorkflowPageNavigationService) {
    super();
  }
}
